import React from 'react';
import {GoodsType} from "../../model/types/goods-type";
import {StyledCard} from "./style";
import Badge from "../../../../shared/ui/badge/Badge";
import ProductPriceWrap from "../../../../shared/ui/price/ProductPriceWrap";
import ProductOldPrice from "../../../../shared/ui/price/ProductOldPrice";
import ProductCurrentPrice from "../../../../shared/ui/price/ProductCurrentPrice";
import {GLOBAL_STYLE_CONFIG} from "../../../../app/styles/GlobalStyles";

interface ICardProps {
    goods: GoodsType;
    slotFavorite?: React.ReactNode,
    slotBasket?: React.ReactNode,
    isSkeleton?: boolean,
    slotPreview?: React.ReactNode,

}

/**
 * Компонент карточки товара.
 *
 * Поддерживает отображение:
 * - Названия товара
 * - Превью изображения (через `slotPreview`)
 * - Цены и старой цены
 * - Бейджа (например, SALE)
 * - Дополнительных действий в виде слотов (избранное, корзина)
 *
 * Пропсы:
 * @param goods - Объект товара (`GoodsType`), содержащий название, цену, валюту и др.
 * @param slotFavorite - Элемент для отображения кнопки добавления в избранное (по желанию)
 * @param slotBasket - Элемент для отображения кнопки корзины (по желанию)
 * @param isSkeleton - Флаг состояния загрузки. При `true` добавляет класс скелетона
 * @param slotPreview - Элемент превью (например, слайдер или изображение товара)
 *
 * @returns JSX.Element - Карточка товара
 */
function GoodsCard({goods, slotBasket, slotFavorite, isSkeleton = false, slotPreview}: ICardProps) {
    return (
        <StyledCard
            className={`
            ${GLOBAL_STYLE_CONFIG.splitByPrefix('card')} 
            ${GLOBAL_STYLE_CONFIG.splitByPrefix('card-goods')} 
            ${isSkeleton ? `${GLOBAL_STYLE_CONFIG.splitByPrefix('card-skeleton')}` : ''}
            `}>
            <div className={GLOBAL_STYLE_CONFIG.splitByPrefix('card-top-actions')}>
                {slotFavorite && (
                    <div className={GLOBAL_STYLE_CONFIG.splitByPrefix('card-slot-favorite')}>{slotFavorite}</div>)}
                <Badge type={'top'} title={'SALE'}/>
            </div>
            <div className={GLOBAL_STYLE_CONFIG.splitByPrefix('card-media')}>
                {slotPreview ? slotPreview : null}
            </div>
            <div className={GLOBAL_STYLE_CONFIG.splitByPrefix('card-content')}>
                <div className={GLOBAL_STYLE_CONFIG.splitByPrefix('card-title')} title={goods.name}>{goods.name}</div>
            </div>
            <div className={GLOBAL_STYLE_CONFIG.splitByPrefix('card-bottom')}>
                <ProductPriceWrap className={GLOBAL_STYLE_CONFIG.splitByPrefix("card-price-wrapper")}>
                    <ProductOldPrice>12 {goods.currency} </ProductOldPrice>
                    {/*{goods.old_price && <ProductOldPrice>{goods.old_price} {goods.currency} </ProductOldPrice>}*/}
                    {goods.price && <ProductCurrentPrice> {goods.price} {goods.currency}</ProductCurrentPrice>}
                </ProductPriceWrap>

                {slotBasket && (<div className={GLOBAL_STYLE_CONFIG.splitByPrefix('card-slot-basket')}>{slotBasket}</div>)}
            </div>
        </StyledCard>
    )
}


export default GoodsCard;